import { render, staticRenderFns } from "./VoteFinalists.vue?vue&type=template&id=0c536b8c&scoped=true"
import script from "./VoteFinalists.vue?vue&type=script&lang=js"
export * from "./VoteFinalists.vue?vue&type=script&lang=js"
import style0 from "./VoteFinalists.vue?vue&type=style&index=0&id=0c536b8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c536b8c",
  null
  
)

export default component.exports